import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { DASHBOARD_CATALOGS } from "./model/dashboard-copy.ts";

export const dashboardBrowserModule: BrowserModule = defineBrowserModule("dashboard")
  .withScreens({
    home: {
      path: "/",
      title: phrase(DASHBOARD_CATALOGS, "screenTitle"),
      layout: "app",
      load: () => import("./ui/sections/dashboard-screen.tsx"),
    },
  })
  .withNavigation([
    {
      id: "dashboard",
      group: "main",
      label: phrase(DASHBOARD_CATALOGS, "navDashboard"),
      href: "/",
      icon: "dashboard",
      order: 0,
    },
  ]);
